import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ReportAction } from '../../store/actions';
import { csvDownload } from '../csv-download';
import Pagination from '../pagination';

class Stock extends PureComponent {
  static propTypes = {
    authHasOffice: PropTypes.bool,
    getStocksReport: PropTypes.func,
    stocks: PropTypes.object,
  };

  componentDidMount() {
    this.props.getStocksReport?.(
      Object?.fromEntries?.(new URLSearchParams(this.props.location?.search)),
    );
  }

  onDownload() {
    csvDownload?.(
      [
        ...(this.props.authHasOffice ? [] : ['Office']),
        'Model',
        'Color',
        'Total',
      ],
      this.props.stocks?.data,
      r => [
        ...(this.props.authHasOffice ? [] : [r.office?.name]),
        r.vehicle?.model,
        r.colors?.map?.(c => `${c.name}:${c.count}`)?.join?.(','),
        r.total,
      ],
      'STOCK-REPORT',
    );
  }

  render() {
    const {
      authHasOffice = false,
      getStocksReport = () => {},
      stocks: { data: stocks = [], links = [] } = {},
    } = this.props;
    return (
      <div className="row">
        <div className="col">
          <div className="card">
            <div className="card-header">
              <h3 className="card-title">Stock</h3>
              <div className="card-tools d-print-none">
                <Pagination getList={getStocksReport} links={links} />
              </div>
              <div className="card-tools d-print-none mr-2">
                <div className="input-group input-group-sm">
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={this.onDownload.bind(this)}
                    type="button"
                  >
                    <i className="fas fa-download"></i>
                  </button>
                </div>
              </div>
            </div>
            <div className="card-body p-0 table-responsive">
              {stocks?.length === 0 && (
                <p className="text-center my-2">No data found.</p>
              )}
              {stocks?.length > 0 && (
                <table className="small table table-sm table-striped text-nowrap">
                  <thead>
                    <tr>
                      {!authHasOffice && <th>Office</th>}
                      <th>Model</th>
                      <th>Color</th>
                      <th className="text-right">Total</th>
                    </tr>
                  </thead>
                  <tbody>
                    {stocks?.map?.((row, i) => (
                      <tr key={i}>
                        {!authHasOffice && <td>{row.office?.name}</td>}
                        <td>{row.vehicle?.model}</td>
                        <td>
                          <div className="d-flex">
                            {row.colors?.map?.(c => (
                              <span
                                className="border-left border-right mr-2 px-2 text-center"
                                key={c.id}
                              >
                                {c.name}
                                <br />
                                {c.count}
                              </span>
                            ))}
                          </div>
                        </td>
                        <td className="text-right">{row.total}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  authHasOffice: !!state?.auth?.office,
  stocks: state?.report?.stocks,
});

const mapDispatchToProps = dispatch => ({
  getStocksReport: params => dispatch(ReportAction.getStocksReport(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Stock);
